export default "__VITE_ASSET__Ch1b9103__"